// Impresión de tickets en ventana limpia para térmicas 58/80 mm (vía navegador, sin agente)
export const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const fila = (l, r, cls = "") => `<div class="f ${cls}"><span>${esc(l)}</span><b>${esc(r)}</b></div>`;
export const sep = () => `<div class="sep"></div>`;
export const centro = (t, cls = "") => `<div class="c ${cls}">${t}</div>`;
export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

function css(ancho) {
  const util = ancho === 58 ? 48 : 72;
  const fs = ancho === 58 ? 12 : 14;
  return `@page{size:${ancho}mm auto;margin:0}*{box-sizing:border-box;margin:0;padding:0}
html,body{width:${ancho}mm;background:#fff;color:#000;zoom:1!important;height:auto;overflow:visible}
body{font-family:Arial,Helvetica,"Liberation Sans",sans-serif;font-size:${fs}px;line-height:1.25;font-weight:400;padding:1mm ${(ancho - util) / 2}mm 2mm;
-webkit-font-smoothing:none;text-rendering:optimizeSpeed;-webkit-print-color-adjust:exact;print-color-adjust:exact}
@media print{html,body{width:${ancho}mm!important;margin:0!important}.item,.box,.f,.big,.firmas{break-inside:avoid;page-break-inside:avoid}}
b{font-weight:400}.f{display:flex;justify-content:space-between;gap:8px}.f>span{flex:1 1 auto}.f>b{flex:0 0 auto;max-width:65%;text-align:right;word-break:keep-all}
.f.xl>b,.f.tot>b,.f.tot>span{font-weight:700}
.c{text-align:center}.sep{border-top:1px dashed #000;margin:4px 0}.item{margin:3px 0;display:block}.item .n{display:block;text-transform:uppercase;line-height:1.15;font-weight:700;word-break:normal;overflow-wrap:anywhere}.item .ql{display:flex;justify-content:space-between;gap:8px;align-items:baseline}.item .q{flex:1 1 auto;white-space:nowrap;font-size:${fs - 1}px}.item .i{flex:0 0 auto;text-align:right;white-space:nowrap;font-weight:700}
.marca{font-size:${fs + 4}px;letter-spacing:.14em;font-weight:700}.tot{font-size:${fs + 5}px;margin-top:4px}
.chico{font-size:${fs - 2}px}.xl{font-size:${fs + 1}px}.up{text-transform:uppercase}.mt{margin-top:4px}.b{font-weight:700}
.box{border:1px solid #000;padding:4px 6px;margin:5px 0}.t{text-transform:uppercase;letter-spacing:.1em;font-size:${fs - 2}px;font-weight:700;margin:7px 0 2px;border-bottom:1px dashed #000;padding-bottom:1px}
.big{font-size:${fs + 3}px;font-weight:700;text-align:center;padding:5px;border:1px solid #000;margin-top:5px}
.firmas{display:flex;gap:10px;margin-top:22px}.firma{flex:1;text-align:center;font-size:${fs - 3}px}.firma div{border-top:1px solid #000;margin-top:26px;padding-top:3px}
img{height:${ancho === 58 ? 64 : 84}px;width:auto;max-width:100%;display:block;margin:0 auto 3px;image-rendering:-webkit-optimize-contrast;image-rendering:crisp-edges}
svg{height:${ancho === 58 ? 28 : 34}px;width:100%;display:block;margin-top:4px}`;
}

/** Logo en data URL (cacheado) para que siempre salga impreso, sin depender de la carga de red. */
let logoCache = null;
export async function logoDataUrl() {
  if (logoCache) return logoCache;
  try {
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = "/rubi-logo.png"; });
    // Binariza a negro puro sobre blanco (sin grises → la térmica no imprime "puntos" de tramado)
    const w = 900, h = Math.round((img.height / img.width) * w);
    const cv = document.createElement("canvas"); cv.width = w; cv.height = h;
    const ctx = cv.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, w, h); ctx.drawImage(img, 0, 0, w, h);
    const d = ctx.getImageData(0, 0, w, h); const p = d.data;
    for (let i = 0; i < p.length; i += 4) { const lum = (p[i] * 0.299 + p[i + 1] * 0.587 + p[i + 2] * 0.114) * (p[i + 3] / 255) + 255 * (1 - p[i + 3] / 255); const v = lum < 170 ? 0 : 255; p[i] = p[i + 1] = p[i + 2] = v; p[i + 3] = 255; }
    ctx.putImageData(d, 0, 0);
    logoCache = cv.toDataURL("image/png");
  } catch { logoCache = ""; }
  return logoCache;
}
export const LOGO = "__LOGO__";
export const logoImg = () => `<img src="${LOGO}" alt="">`;

/** Abre ventana solo con el ticket e imprime una vez. Blindado: logo con tiempo límite, escritura inmediata y respaldo por iframe si el navegador bloquea la ventana.
 *  La hoja se ajusta al alto real del contenido (una sola página continua) para que no salga "en partes" en ninguna PC ni con zoom del navegador. */
export async function abrirTicket(cuerpo, ancho = 80, titulo = "Ticket") {
  const logo = await Promise.race([logoDataUrl(), new Promise((r) => setTimeout(() => r(""), 1200))]).catch(() => "");
  const html = `<!doctype html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=${ancho}mm,initial-scale=1"><title>${esc(titulo)}</title><style>${css(ancho)}</style><style id="pg"></style></head><body>${(cuerpo || "").replaceAll(LOGO, logo || "")}</body></html>`;
  const ajustarPagina = (doc) => {
    try {
      const pxMm = 25.4 / 96;
      const alto = Math.ceil(Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight) * pxMm) + 6;
      // El alto siempre mayor que el ancho: si fuera menor (tickets cortos) el driver lo toma como hoja apaisada y lo gira
      doc.getElementById("pg").textContent = `@page{size:${ancho}mm ${Math.min(Math.max(alto, Number(ancho) + 30), 3000)}mm;margin:0}`;
    } catch { /* ignorar */ }
  };
  const imprimirEn = (win, cerrar) => {
    let hecho = false;
    const lanzar = () => { if (hecho) return; hecho = true; ajustarPagina(win.document); try { win.focus(); win.print(); } catch { /* ignorar */ } if (cerrar) setTimeout(cerrar, 800); };
    const doc = win.document;
    const imgs = [...doc.images];
    Promise.all(imgs.map((i) => (i.complete ? null : new Promise((r) => { i.onload = r; i.onerror = r; })))).then(() => setTimeout(lanzar, 120));
    setTimeout(lanzar, 1500);
  };
  // Siempre por iframe oculto en la misma pestaña: imprime y se limpia solo, sin abrir ventanas ni pestañas.
  const f = document.createElement("iframe");
  f.setAttribute("data-testid", "ticket-iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(f);
  const d = f.contentWindow.document;
  d.open(); d.write(html); d.close();
  imprimirEn(f.contentWindow, () => setTimeout(() => f.remove(), 60000));
  return true;
}
